<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="售后类型" label-width="80px">
						<el-select v-model="searchInfo.type" placeholder="请选择">
							<el-option key="1" label="仅退款" :value="1">仅退款</el-option>
							<el-option key="2" label="退货退款" :value="2">退货退款</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="售后订单状态" label-width="120px">
						<el-select v-model="searchInfo.isFinish" placeholder="请选择">
							<el-option key="0" label="处理中" :value="0">处理中</el-option>
							<el-option key="1" label="售后完成" :value="1">售后完成</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column type="index" align="center" width="50" label="#">
			</el-table-column>
			<el-table-column prop="orderCode" label="订单编号" align="center" width="200" >
			</el-table-column>
            <el-table-column prop="returnCode" label="售后编号" align="center" width="200" >
			</el-table-column>
            
			<el-table-column  prop="corderCode" label="三方订单号" align="center" width="200" >
			</el-table-column>
            <el-table-column prop="goodsName" label="商品名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <!-- <el-table-column prop="name" label="商品图片" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
            <el-table-column prop="num" label="数量" align="center" width="" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span>x{{ scope.row.num }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="amount" label="退款金额(￥)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="type" label="售后类型" align="center" width="" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span  v-if="scope.row.type==1">仅退款</span>
					<span  v-if="scope.row.type==2">退货退款</span>
				</template>
			</el-table-column>
            <el-table-column prop="isFinish" label="售后订单状态" align="center" width="" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span v-if="scope.row.isFinish">售后完成</span>
                    <span v-else>处理中</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="name" label="收件人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="phone" label="手机号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column v-if="storeType==3"  prop="bstoreName" label="分销商名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column v-if="storeType==3"  prop="sstoreName" label="供应商名称" align="center" width="90" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="totalPrice" label="订单总价(￥)" align="center" width="120"
				:show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="status" label="状态" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0">待扣款</span>
					<span v-if="scope.row.status==1">待发货</span>
					<span v-if="scope.row.status==2">待收货</span>
					<span v-if="scope.row.status==3">已完成</span>
					<span v-if="scope.row.status==4">退款申请</span>
					<span v-if="scope.row.status==5">已退款</span>
					<span v-if="scope.row.status==6">部分退款</span>
					<span v-if="scope.row.status==7">已失效</span>
					<span v-if="scope.row.status==8">驳回</span>
					<span v-if="scope.row.status==9">取消</span>
				</template>
			</el-table-column> -->
			<!-- <el-table-column prop="address" label="详细地址" align="center" width="180" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}{{scope.row.address}}</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="returnDate" label="申请售后时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" width="180" :show-overflow-tooltip="true">

				<template slot-scope="scope">
                    <el-button size="small" type="text" @click="showContent(scope.row,1)">详情</el-button>
                    <el-button size="small" type="text" v-if="storeType == 1 && scope.row.status==1"
					 @click="showContent(scope.row,2)">审核</el-button>
					<el-button size="small" type="text" v-if="storeType == 2 && scope.row.type==2 && scope.row.status==2"
					 @click="salesReturn(scope.row)">退货</el-button>
					<el-button size="small" type="text" v-if="storeType == 3 && !scope.row.isFinish"
					 @click="showContent(scope.row,3)">退款</el-button>
					<el-button size="small" type="text" v-if="storeType == 1 && scope.row.status==3&&scope.row.type==2"
					 @click="showContent(scope.row,4)">收货</el-button>
					
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 售后详情对话框 -->
		<el-dialog title="售后详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<div>
                <!-- 仅退款 -->
                <el-steps :active="orderInfo.status" v-if="orderInfo.type == 1">
                    <el-step title="已发起申请" icon="el-icon-circle-check"></el-step>
                    <el-step v-if="orderInfo.isAgree!=null" :title="orderInfo.isAgree?'商家同意申请':'商家不同意申请'" :icon="orderInfo.isAgree?'el-icon-circle-check':'el-icon-circle-close'"></el-step>
                    <el-step v-else title="商家同意申请" icon="el-icon-circle-check"></el-step>
                    <el-step title="售后完成" icon="el-icon-circle-check"></el-step>
                </el-steps>
                <!-- 退货退款 -->
                <el-steps :active="orderInfo.status" v-if="orderInfo.type == 2">
                   <el-step title="已发起申请" icon="el-icon-circle-check"></el-step>
                   <el-step v-if="orderInfo.isAgree!=null" :title="orderInfo.isAgree?'商家同意申请':'商家不同意申请'" :icon="orderInfo.isAgree?'el-icon-circle-check':'el-icon-circle-close'"></el-step>
                    <el-step v-else title="商家同意申请" icon="el-icon-circle-check"></el-step>
                    <el-step title="买家已发货" icon="el-icon-circle-check"></el-step>
                    <el-step :title="orderInfo.isAgreeGys==1 ?'商家已收货':'商家未收货'" :icon="orderInfo.isAgreeGys?'el-icon-circle-check':'el-icon-circle-close'"></el-step>
                    <el-step title="售后完成" icon="el-icon-circle-check"></el-step>
                </el-steps>
               
				<div class="grid-content" style="margin-top:30px">
					<div>
						<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">订单信息</div>
						<div style="display: flex;">
							<img :src="orderInfo.goodsImages" alt="" style="width:100px;height:100px;margin-right:20px">
							<div>
								{{orderInfo.goodsName?orderInfo.goodsName:'暂无'}}
							</div>
						</div>
						<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
							<el-form-item label="订单号">
								<span>{{orderInfo.orderCode?orderInfo.orderCode:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="三方订单号">
								<span>{{orderInfo.corderCode?orderInfo.corderCode:'暂无'}}</span>
							</el-form-item>

							<el-form-item label="收货人">
								<span>{{orderInfo.buyerName?orderInfo.buyerName:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="联系电话">
								<span>{{orderInfo.buyerPhone?orderInfo.buyerPhone:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="详细地址">
								<span>{{orderInfo.buyerAddress}}</span>
							</el-form-item>
							<el-form-item label="购买时间">
								<span>{{orderInfo.createTime?orderInfo.createTime:'暂无'}}</span>
							</el-form-item>
						</el-form>
					</div>
					<div>
						<div style="margin:10px 0 ;font-size:18px;font-weight: bold;margin-top:30px">售后信息</div>
						<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
							<el-form-item label="售后编号">
								<span>{{orderInfo.returnCode?orderInfo.returnCode:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="售后类型">
								<span v-if="orderInfo.type == 1">仅退款</span>
								<span v-if="orderInfo.type == 2">退货退款</span>
							</el-form-item>
							<el-form-item label="售后结果">
								<span v-if="orderInfo.isFinish">售后完成</span>
								<span v-else>处理中</span>
							</el-form-item>
							<el-form-item label="退款金额">
								<span>{{orderInfo.amount ?"￥"+orderInfo.amount:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="退款状态" >
								<span v-if="orderInfo.isFinish">已退款</span>
								<span v-else>待退款</span>
							</el-form-item>
							<el-form-item label="售后说明" >
								<span>{{orderInfo.reason?orderInfo.reason:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="售后申请时间">
								<span>{{orderInfo.returnDate?orderInfo.returnDate:'暂无'}}</span>
							</el-form-item>
							<el-form-item label="申请凭证">
								<!-- <div v-if="orderInfo.images.length==0">暂无</div> -->
								<div v-for="(it,index) in orderInfo.images" :key="index"
								style="margin-right:20px;display: inline-block;">
									<img :src="it"  v-if="it" style="width:200px;height:200px;margin-bottom:10px">
								</div>
							</el-form-item>
						</el-form>
					</div>
					
				</div>
				
				<div>
					<div style="margin:10px 0 ;color: #000000;font-size:18px;font-weight: bold;margin-top:30px">
						售后处理记录</div>
					<div id="steps-box">
						<el-steps direction="vertical" :active="1" space="100px">
							<el-step v-for="(i,index) in disposeInfo" :key="index">
								<template slot="icon">
									<img v-if="i.roleType ==2" src="../../assets/sell.png" style="width:18px;height:18px">
									<img v-if="i.roleType ==1" src="../../assets/buy.png" style="width:30px;height:30px">
									<img v-if="i.roleType ==3" src="../../assets/pc.png" style="width:18px;height:18px">
								</template>
								<template slot="title">
									<span v-if="i.roleType ==2">商家</span>
									<span v-if="i.roleType ==1">买家</span>
									<span v-if="i.roleType ==3">平台</span>
								</template>
								<template slot="description" class="description">
									<div style="font-weight: bold;font-size:16px">{{ i.message }}</div>
									<div>售后类型：
										<span v-if="orderInfo.type == 1">仅退款</span>
										<span v-if="orderInfo.type == 2">退货退款</span>
									</div>
									<div v-if="i.roleType ==1">
										<!-- 买家 -->
										<div v-if="i.message=='买家发起售后申请'">
											<div>退款金额：￥{{ i.price }}</div>
											<div>联系电话：{{ i.tel }}</div>
											<div>说明：{{ i.reason }}</div>
											</div>
										<div v-if="i.message=='买家已发货'">
											<div>快递公司：{{ i.company }}</div>
											<div>快递单号：{{ i.sn }}</div>
										</div>
									</div>
									<div v-if="i.roleType ==2">
										<!-- 商家 -->
										<div v-if="i.rejectReason!=null">说明：{{	i.rejectReason }}</div>
										<div v-if="orderInfo.isAgree==1 && i.realMoney!=null">实际退款金额：￥{{ i.realMoney }}</div>
										<div v-if="orderInfo.type == 2&&i.message=='商家同意申请'">
											<div>收货人姓名：{{ i.realName }}</div>
											<div>收货人电话：{{ i.phone  }}</div>
											<div>收货人地址：{{ i.address  }}</div>
										</div>
									</div>
									<div v-if="i.roleType ==3">
										<!-- 平台 -->
										<!-- <div>售后类型：
											<span v-if="orderInfo.type == 1">仅退款</span>
											<span v-if="orderInfo.type == 2">退货退款</span>
										</div> -->
										<div v-if="i.rejectReason!=null">说明：{{	i.rejectReason }}</div>
										<div v-if="orderInfo.isAgreePc==1 && i.realMoney!=null">实际退款金额：￥{{ i.realMoney }}</div>
									</div>
									<div>时间：{{ i.updateTime }}</div>
								</template>
							</el-step>
						</el-steps>
					</div>
				</div>

				<div v-if="storeType == 1&&clickType==2" style="margin-top:30px">
					<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">商家审核</div>
					<el-form v-model="applyInfo" label-position="left" inline class="demo-table-expand">
					<div>
						<el-form-item label="审核类型">
							<el-radio-group v-model="applyInfo.applyType">
								<el-radio label="1">同意申请</el-radio>
								<el-radio label="0">不同意申请</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="审核说明">
							<el-input type="textarea" clearable v-model="applyInfo.afterSaleRemark" placeholder="请输入文字说明" 
							style="width:400px"/>
						</el-form-item>
						
					</div>
						<div v-if="storeType == 1 && orderInfo.type == 2" >
							<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">填写收件人信息</div>
							<el-form-item label="收件人姓名">
								<el-input v-model="applyInfo.receiveName" placeholder="请输入收件人姓名"></el-input>
							</el-form-item>
							<el-form-item label="收件人电话" label-width="120px">
								<el-input v-model="applyInfo.receivePhone" placeholder="请输入收件人电话"></el-input>
							</el-form-item>
							<div style="height:20px"></div>
							<el-form-item label="收件人地址" >
								<el-input v-model="applyInfo.receiveAddress" placeholder="请输入收件人地址" style="width:600px"></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>

				<div v-if="storeType == 2&&clickType==2" style="margin-top:30px">
					<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">买家上传退货信息</div>
					<div>
						<el-form v-model="applyInfo" label-position="left" inline class="demo-table-expand">
							<el-form-item label="审核类型">
								<el-radio-group v-model="applyInfo.applyType">
									<el-radio label="1">同意申请</el-radio>
									<el-radio label="0">不同意申请</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="审核说明">
								<el-input type="textarea" clearable v-model="applyInfo.afterSaleRemark" placeholder="请输入文字说明" 
								style="width:400px"/>
							</el-form-item>
						</el-form>
					</div>
				</div>
				
				<div v-if="storeType == 3&&clickType==3" style="margin-top:30px">
					<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">审核</div>
					<div>
						<el-form v-model="applyInfoAdmin" label-position="left" inline class="demo-table-expand">
							<el-form-item label="审核类型">
								<el-radio-group v-model="applyInfoAdmin.applyType">
									<el-radio label="1">同意退款</el-radio>
									<el-radio label="0">不同意退款</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="审核说明">
								<el-input type="textarea" clearable v-model="applyInfoAdmin.afterSaleRemark" placeholder="请输入文字说明" 
								style="width:400px"/>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div v-if="storeType == 1&&clickType==4" style="margin-top:30px">
					<div style="margin:10px 0 ;font-size:18px;font-weight: bold;">收货</div>
					<div>
						<el-form v-model="applyInfoSell" label-position="left" inline class="demo-table-expand">
							<el-form-item label="是否收到退货物品" label-width="200px">
								<el-radio-group v-model="applyInfoSell.applyType">
									<el-radio label="1">是</el-radio>
									<el-radio label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="说明">
								<el-input type="textarea" clearable v-model="applyInfoSell.afterSaleRemark" placeholder="请输入文字说明" 
								style="width:400px"/>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- 商家是否同意申请和上传收货人信息 -->
				<el-button  v-if="storeType == 1 && clickType==2" type="primary" @click="yesApply(orderInfo.id)">确定</el-button>
				<!-- 平台是否同意退款 -->
				<el-button  v-if="storeType == 3 && clickType==3" type="primary" @click="yesApplyAdmin(orderInfo.id)">确定</el-button>
				<!-- 商家是否收到退货物品 -->
				<el-button  v-if="storeType == 1 && clickType==4" type="primary" @click="yesApplySell(orderInfo.id)">确定</el-button>
				<el-button  @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		
		<el-dialog style="float:rigin;overflow-y: scroll;" title="物流详情" :visible.sync="ExpDialog" width="60%"
			:close-on-click-modal="false">
		
				<el-steps :active="wudetail.length" align-center direction="vertical">
				  <el-step v-for="(item,index) in wudetail" :key="index"  :title="item.context" :description="item.ftime"></el-step>
				</el-steps>
		</el-dialog>

		<!-- 发货 -->
		<el-dialog style="float:rigin" title="退货" :visible.sync="deliverDialog" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<!-- <el-form-item label="订单号:">
						<span>{{orderCode}}</span>
					</el-form-item> -->
					<el-form-item label="收货人姓名:">
						<!-- <div v-if="orderInfo.type == 2">收货人姓名：{{ i.realName }}</div>
							<div v-if="orderInfo.type == 2">收货人电话：{{ i.phone  }}</div>
							<div v-if="orderInfo.type == 2">收货人地址：{{ i.address  }}</div> -->
						<span>{{salesReturnInfo.realName}}</span>
					</el-form-item>
					<el-form-item label="收货人电话:">
						<span>{{salesReturnInfo.phone}}</span>
					</el-form-item>
					<el-form-item label="收货地址:">
						<span>{{salesReturnInfo.address}}</span>
					</el-form-item>
					<el-form-item label="物流:">
						<el-col :span="12">
							<el-select clearable filterable v-model="expressId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in expressList" :key="item.id" :value="item.expressName"
									:label="item.expressName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					
					<el-form-item label="快递单号:">
						<el-col :span="15">
							<el-input type="text" v-model="expressCode" placeholder="请输入快递单号" />
						</el-col>
					</el-form-item>
					<!-- <el-form-item label="发货人:">
						<el-col :span="15">
							<el-input type="text" v-model="sendOpUser" placeholder="请输入发货人" />
						</el-col>
					</el-form-item>
					<el-form-item label="发货备注:">
						<el-col :span="15">
							<el-input type="text" v-model="sendRemark" placeholder="请输入发货备注(非必填)" />
						</el-col>
					</el-form-item> -->
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deliverDialog = false">取 消</el-button>
				<el-button type="primary" @click="deliverGoods()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import XLSX from 'xlsx'
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		data() {
			return {
				uploadUrl: urls,
				dzform:{},
				DzDialog:false,
				ExpDialog:false,
				loading: false,
				orderList: [],
				dialogVisible: false,
				searchInfo: {},
				orderInfo: {},
				orderInfoAfterSale:{}, //售后数据
				loadinglog:false,
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				wudetail:[{}],
				tableData:[{}],
				cityList: {},
				districtList: {},
				deliverDialog: false, //发货弹窗
				sendOpUser: '', // 发货人
				expressCode: '', // 快递订单号
				expressId: '', // 快递公司id
				sendRemark:'', //发货备注
				expressList: [], //快递公司列表
				showOrderInfo: [], //发货订单信息
				accountList: [], //选择框供应商数据
				distributionList: [], //选择框分销商数据
				storeType:'',
				orderCode:'',
				name:'',
				address:'',
				sType:'',
				BatchDialog:false,
				afterSaleFlage:false, //售后对话框
				afterSaleType: '', //售后类型
				goodsImages: [],
				fileList: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				applyInfo: {
					applyType:'',
					afterSaleRemark:''
				}, //商家审核
				disposeInfo:{}, //售后处理记录
				clickType: 1, //详情和审核点击类型 
				salesReturnInfo:{}, //商家收货信息
				goodsReturnsId : '', //表格id(买家上传退货信息时使用)
				applyInfoAdmin: {
					applyType:'',
					afterSaleRemark:''
				}, //平台审核
				applyInfoSell: {
					applyType:'',
					afterSaleRemark:''
				}, //商家是否收货
			};
		},
		methods: {
			yesApply(e){ //商家审核
				// console.log('售后详情---', e)
				// console.log('商家审核---',this.applyInfo)
				if(this.applyInfo.applyType == ''){ //
					this.$message.error('审核类型不能为空');
					return
				}
				if(this.applyInfo.applyType == 0 && this.applyInfo.afterSaleRemark== ''){ //商家不同意
					this.$message.error('审核说明不能为空');
					return
				}
				
				let data = {
					"id": e,
					"isAgree": this.applyInfo.applyType, //同意1，不同意0
					"rejectReason": this.applyInfo.afterSaleRemark, //说明
					"realName": this.applyInfo.receiveName, //收件人姓名
					"phone": this.applyInfo.receivePhone, //收件人电话
					"address": this.applyInfo.receiveAddress //收件人地址
				}
				// console.log('商家审核信息---',data)
				this.$api.sellAuditAfterSale(data).then((res) => {
					if (res.state == 'success') {
						this.$message.success(res.message)
						this.storeOrderList()
						this.dialogVisible = false;
						// console.log('商家审核售后--',res)
					} else {
						this.$message.error(res.message)
					}
				})

			},
			yesApplyAdmin(e){ //平台审核
				// console.log('平台审核---',this.applyInfoAdmin)
				if(this.applyInfoAdmin.applyType == ''){ //
					this.$message.error('审核类型不能为空');
					return
				}
				if(this.applyInfoAdmin.applyType == 0 && this.applyInfoAdmin.afterSaleRemark== ''){ //商家不同意
					this.$message.error('审核说明不能为空');
					return
				}

				let data = {
					"id": e,
					"isAgreePc": this.applyInfoAdmin.applyType, //同意1，不同意0
					"rejectReason": this.applyInfoAdmin.afterSaleRemark, //说明
				}
				// console.log('平台审核信息---',data)
				this.$api.adminAuditRefund(data).then((res) => {
					if (res.state == 'success') {
						this.$message.success(res.message)
						this.storeOrderList()
						this.dialogVisible = false;
						// console.log('平台审核信息--',res)
					} else {
						this.$message.error(res.message)
					}
				})
			},
			yesApplySell(e){ //商家是否收货
				if(this.applyInfoSell.applyType == ''){ //
					this.$message.error('类型不能为空');
					return
				}
				if(this.applyInfoSell.applyType == 0 && this.applyInfoSell.afterSaleRemark== ''){ //商家不同意
					this.$message.error('说明不能为空');
					return
				}

				let data = {
					"id": e,
					"isAgreeGys": this.applyInfoSell.applyType, //同意1，不同意0
					"rejectReason": this.applyInfoSell.afterSaleRemark, //说明
				}
				// console.log('商家是否收货信息---',data)
				this.$api.sellAuditSignFor(data).then((res) => {
					if (res.state == 'success') {
						this.$message.success(res.message)
						this.storeOrderList()
						this.dialogVisible = false;
						// console.log('商家是否收货信息--',res)
					} else {
						this.$message.error(res.message)
					}
				})
			},
			delexcel(uid){
				this.$confirm('确定删除该订单嘛？', '删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
						this.tableData=this.tableData.filter(item=>item.uid!=uid);
							this.$message({
								message: '删除成功',
								type: 'success'
							});
						
						
					
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			
			
				
				
			},
			uploadExcel(){
				this.$api.mbExcal().then(res=>{
					// console.log(res);
					this.showloadFile(res.data)
				})
			},
			/**
			 * 文件导出
			 */
			downloadFile() {
				let data = {
					name: this.searchInfo.name,
					phone: this.searchInfo.phone,
					orderCode: this.searchInfo.orderCode,
					expressCode: this.searchInfo.expressCode,
					
					code: this.searchInfo.cOrderCode,
					status: this.searchInfo.status,
					type: this.searchInfo.type,
					provinceId: this.searchInfo.provinceId,
					cityId: this.searchInfo.cityId,
					areaId: this.searchInfo.areaId,
					// supplierId: this.searchInfo.supplierId,
					supplierName: this.searchInfo.supplierName,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					bstoreId: this.searchInfo.bstoreId, //分销商
					sstoreId: this.searchInfo.sstoreId, //供应商
				}
				this.$api.orderExcal(data).then((res) => {
				
					this.showloadFile(res.data)
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '商城订单' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},

			 /**
			     * 解析文件
			     * @param {Object} file
			     */
			    file2Xce(file) {
			      return new Promise(function(resolve, reject) {
			        const reader = new FileReader();
			        reader.onload = function(e) {
			          const data = e.target.result;
			          this.wb = XLSX.read(data, {
			            type: "binary"
			          });
			          const result = [];
			          this.wb.SheetNames.forEach(sheetName => {
			            result.push({
			              sheetName: sheetName,
			              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
			            });
			          });
			          /* console.log("解析")
			          console.log(result) */
			          resolve(result);
			        };
			        reader.readAsBinaryString(file.raw);
			      });
			    },
			//快递公司列表
			findExpress() {
				this.$api.findAllOrderExpressList({}).then((res) => {
					if (res.state == 'success') {
						this.expressList = res.data.list
					}
				})
			},
			lookexp(id){
				// console.log(id);
					
				this.$api.lookExpress(id).then(res=>{
					
					if(res.state=='success'){
						this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()
			},
			// 清空
			empty() {
				this.searchInfo = {}
			},
			storeOrderList() {
				this.loading = true
				
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					type: this.searchInfo.type,
					isFinish: this.searchInfo.isFinish,
					
				}
				this.$api.getOrderAfterSaleInfo(data).then((res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('查询时的表格数据--',res)
					if (res.state == 'success') {
						this.orderList = res.data.list
						this.sliderlist = res.data
						this.loading = false
					}
				}))
				//查询省
				this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			//查询市
			provinceFocus1(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.dzform.province = obj.name
				this.dzform.provinceId = e
				this.dzform.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus1(e) {
				this.dzform.cityId = e
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.dzform.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
			
			},
			
			// districtFcus1(e) {
			// 	this.dzform.areaId = e
			// 	let obj = {};
			// 	obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
			// 		return item.id === e; //筛选出匹配数据
			// 	});
			// 	this.dzform.area = obj.name
			// },
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			// districtFcus(e) {
			// 	let obj = {};
			// 	obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
			// 		return item.id === e; //筛选出匹配数据
			// 	});
			// 	this.orderInfo.area = obj.name
			// },
			// 售后详情查询
			showContent(e,num) {
				//num: 1、详情(无操作) 2、审核(供应商审核操作) 3、平台退款(退款操作)  4、收货(供应商收货操作)
				this.clickType = num;
				this.orderInfo = {};
				this.applyInfo.afterSaleRemark = ''; //备注说明
				this.applyInfo.applyType = ''; //售后类型
				this.applyInfoAdmin.afterSaleRemark = ''; //平台审核备注说明
				this.applyInfoAdmin.applyType = ''; //平台审核类型
				// console.log('点击表格信息---',e)
				this.$api.getOrderAfterSaleByID(e.id).then((res) => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('售后详情--',res.data)
					if (res.state == 'success') {
						this.orderInfo = res.data
						this.dialogVisible = true
						this.$set(this.orderInfo,'images',res.data.images.split(','))
						this.getDisposeInfo(e)
						// console.log('申请凭证----',res.data.images.split(','))
						// console.log('售后详情--',this.orderInfo)
					} else {
						this.$message.error(res.message)
					}
				})
			},
			salesReturn(e){ //买家上传发货信息
				// console.log('点击表格信息---',e)
				this.salesReturnInfo = {};
				this.goodsReturnsId = e.id; //表格id(买家上传退货信息时使用)
				this.findExpress();
				let data={
					goodsReturnsId: e.id
				}
				this.$api.orderAfterSaleByID(data).then((res) => {
					// console.log('售后处理记录--',res.data)
					if (res.state == 'success') {
						this.salesReturnInfo = res.data.list
						res.data.list.forEach((it)=>{
							if(it.roleType ==2 && it.address!=null){
								this.salesReturnInfo = it
							}
						})
						this.deliverDialog = true
					} else {
						this.$message.error(res.message)
					}
				})
				
			},
			deliverGoods() { //买家确认发货
				var data = {
					// expressCode: this.expressCode,
					// sendOpUser: this.sendOpUser,
					// expressId: this.expressId,
					// id: this.showOrderInfo.id

					"goodsReturnsId": this.goodsReturnsId,
					"company": this.expressId,
					"sn": this.expressCode
				}
				// console.log('买家退货快递信息---',data)
				this.$api.uploadingExpressage(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.deliverDialog = false
					} else {
						this.$message.error(res.message);
					}
				})

			},
			getDisposeInfo(e){
				this.disposeInfo = {};
				let data={
					goodsReturnsId: e.id
				}
				this.$api.orderAfterSaleByID(data).then((res) => {
					// console.log('售后处理记录--',res.data)
					if (res.state == 'success') {
						this.disposeInfo = res.data.list
						
						// this.$nextTick(()=>{
						// 	let box = document.getElementById('steps-box')
						// 	let x = box.querySelectorAll(".el-step__icon-inner")
						// 	// console.log('')
						// 	x.forEach((item,index)=>{
						// 		item.innerHTML = x.length-index
						// 	})
						// })
					} else {
						this.$message.error(res.message)
					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			searchStore() {
				// 1:供应商  2:分销商
				this.$api.orderListGetInfo(1).then((res) => {
					if (res.state == 'success') {
						// console.log('11--',res.data)
						//此行代码会出现供应商错误
						// this.storeGoodsInfo.storeId = res.data.list[0].id
						this.accountList = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			searchStoreTwo() {
				// 1:供应商  2:分销商
				this.$api.orderListGetInfo(2).then((res) => {
					if (res.state == 'success') {
						// console.log('22--',res.data)
						//此行代码会出现供应商错误
						// this.storeGoodsInfo.storeId = res.data.list[0].id
						this.distributionList = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getStoreAndUser(e){ //供应商选择
				this.searchInfo.sstoreId = e;
			},
			getStoreAndUserTwo(e){ //分销商选择
				// console.log('eerr--',e)
				this.searchInfo.bstoreId = e;
			},
		},

		created() {
			this.$api.getUserInfo().then((res) => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					this.storeType = res.data.user.storeType
					// console.log(this.storeType);
				}
			})
			this.storeOrderList();
			this.searchStore();
			this.searchStoreTwo();
		},
	};
</script>

<style lang="less" scoped>
    
    .grid-content {
        color: #000000;
        text-align: left;
        width: 90%;
    }
    

	// 售后弹出框样式
	.afterSale-item{
		border: 1px solid #e2e2e2;
		padding: 10px 20px;
		border-radius: 10px;
		
	}

	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;
		align-content: flex-start;
		// border: 1px solid red;
	}
	.orderxq-txt{
		margin-left:20px;
		p{
			margin: 0;
			margin-bottom: 10px;
		}
	}	

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
	
	
	// .has-gutter{

	// }

	// #steps-box{ //售后处理记录
	// 	// border: 1px solid red;
	// 	font-weight: bold;
	// }
	#steps-box{
		/deep/.el-step__description{
			background-color: #f7f5f5;
			// background: rgb(116, 116, 116);
			color: #000000;
			padding: 10px;
			div{
				margin-bottom: 10px;
			}
		}
	}
	
</style>
